import { forgeView } from '@/utils/forge-helpers/general'

const NO_HISTORY = null

const { getForgeHistory } = (() => {
  let history = NO_HISTORY
  let isFailed = false

  return {
    getForgeHistory: async () => {
      if (!forgeView) return NO_HISTORY

      if (isFailed) return NO_HISTORY

      if (!history) {
        try {
          history = await forgeView.createHistory()
        } catch (error) {
          console.error('Failed to create Forge history:', error)
          history = NO_HISTORY
          isFailed = true
        }
      }

      return history
    }
  }
})()

export { getForgeHistory }
